import { StorageService } from '@nextgen-web-framework/core';
import { Cart, CartEntryDetails, ErrorResponse, OrderType } from '../services';
import { CartConstantsEnum, CartEventsEnum } from '../types';
import { CartResponse } from '../services/models/CartResponse';
import { SubCartDetail } from '../services/models/SubCartDetail';
import {
  CART_TYPE,
  allProductDetailsForEventPublish,
  getErrorFromEntryOrSubCart,
  isGroupOrder,
  isRegularOrder,
} from './cartCommonHelpers';
import { CartEvents } from './cartEventsUtil';

export const updateEntriesFromCheckoutData = (
  cartCheckoutData: {
    subCarts?: SubCartDetail[];
  },
  cartData: Cart,
) => {
  const updatedSubCartsEntries = { ...cartData, subCarts: [] } as Cart;
  const mainCartId = StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartId);
  const mainCart = cartData?.subCarts?.find(({ subCartId }) => subCartId === mainCartId) as SubCartDetail;
  const inventoryChangedEntries = cartCheckoutData.subCarts?.find(({ subCartId }) => subCartId === mainCartId)?.entries;
  if (cartCheckoutData.subCarts && cartCheckoutData.subCarts.length > 0) {
    if (!isGroupOrder(cartData?.orderType)) {
      const updatedMainCart = { ...mainCart };
      const updatedMainCartEntries = mainCart?.entries?.map((entry: CartEntryDetails) => {
        const localEntry = inventoryChangedEntries?.find((ent: CartEntryDetails) => ent.entryId == entry.entryId);
        const updatedEntry = { ...entry, errors: [] };
        if (localEntry) {
          (updatedEntry.errors as ErrorResponse[]).push({
            params: {
              checkoutInventoryError: getErrorFromEntryOrSubCart(localEntry)?.params?.checkoutInventoryError,
            },
          });

          return updatedEntry;
        }
        return entry;
      }) as CartEntryDetails[];
      updatedMainCart.entries = updatedMainCartEntries;
      updatedMainCartEntries?.length > 0 && updatedSubCartsEntries.subCarts?.push(updatedMainCart);
    } else {
      const subCartCheckoutDataIds = (cartCheckoutData as Cart)?.subCarts?.map((subCart) => subCart.subCartId);
      const updatedSubCarts = cartData?.subCarts?.map((subCart) => {
        if (subCartCheckoutDataIds?.includes(subCart.subCartId)) {
          const updatedSubCart = { ...subCart, errors: [] };
          (updatedSubCart.errors as ErrorResponse[])?.push({
            params: {
              cartId: subCart.subCartId,
              checkoutInventoryError: 'QUANTITY_UPDATED',
            },
          });
          return updatedSubCart;
        }

        return subCart;
      });

      (updatedSubCartsEntries as Cart).subCarts = updatedSubCarts;
    }
    return updatedSubCartsEntries;
  } else {
    return cartData;
  }
};

export const tealiumEventPublisher = (cart: CartResponse, event: CartEventsEnum, fn?: Function) => {
  const {
    productBVs,
    productBrands,
    productIds,
    productNames,
    productPVs,
    productUnitPrices,
    productUnits,
    productPromo,
    productReferrer,
  } = allProductDetailsForEventPublish(cart);

  const payload = {
    cart: cart,
    cartId: StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartId),
    cart_type: cart?.orderType === OrderType.Gco ? CART_TYPE.GROUP : CART_TYPE.PERSONAL,
    cart_promo: cart.subCarts[0].promotionResults?.firedPromotions?.map((promo) => promo?.promotion?.promoCode),
    product_brand: productBrands,
    product_businessVolume: productBVs,
    product_id: productIds,
    product_name: productNames,
    product_pointValue: productPVs,
    product_unitPrice: productUnitPrices,
    product_units: productUnits,
    product_promo: productPromo,
    product_referrer: productReferrer,
  };
  CartEvents.publishEvent({
    event,
    payload,
  });
  fn?.();
};

export const showEmptyCart = ({
  cart,
  activeCart,
  cartId = '',
  isLoading,
}: {
  cart: CartResponse;
  activeCart: SubCartDetail;
  cartId: string;
  isLoading: boolean;
}): boolean => {
  if (isLoading) {
    return false;
  }
  const emptyCartcondition =
    !activeCart ||
    !activeCart?.entries ||
    activeCart?.entries?.length === 0 ||
    !cart.subCarts ||
    cart.subCarts?.length === 0;

  if (isGroupOrder(cart.orderType)) {
    return emptyCartcondition && (!!cartId as boolean);
  }
  return emptyCartcondition;
};

export const getLoaderType = (
  cart: CartResponse,
  isToggled: boolean,
  gcoFlagLS: boolean,
  CartLoaderType: Record<string, string>,
) => {
  if (isToggled) {
    return isRegularOrder(cart.orderType) || OrderType.Proxy ? CartLoaderType.NORMAL : CartLoaderType.GCO;
  }

  return gcoFlagLS ? CartLoaderType.GCO : CartLoaderType.NORMAL;
};
